import PDFIcon from "../../Images/pdfIcon.png";

const ScrutinizerReport = () => {
  const documents = [
    // Add documents here when available:
    // {
    //   title: "Scrutinizer Report - AGM 2025",
    //   buttonLabel: "View Scrutinizer Report",
    //   fileName: "FILENAME.pdf",
    // },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
              <h2 className="site-title">Scrutinizer <span>Report</span></h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.length > 0 ? (
            documents.map((doc, id) => (
              <div className="col-md-6 col-lg-4" key={id}>
                <div className="team-item p-3">
                  <img src={PDFIcon} alt="pdf icon" />
                  <div className="team-content">
                    <div className="team-bio">
                      <h5>{doc.title}</h5>
                      <a
                        className="theme-btn mt-2"
                        href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc.buttonLabel}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p style={{ color: "#888", fontSize: "16px", textAlign: "center", padding: "40px 0" }}>
                Documents will be available here shortly.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScrutinizerReport;
